<template>
  <v-container fluid>
  <section>
    <!-- KPI summary cards -->
    <KpiCards class="mb-4" :items="kpiItems" :loading="loadingSummary" :skeleton="4" />

    <data-table :headers="headers" :items="suppliers" commit="SET_SUPPLIERS">
      <div slot="activator" class="row mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
          <v-card-title class="px-0 pt-0 ps-products-title"> {{ $t("supplier") }} </v-card-title>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <v-spacer />
      </div>
    </data-table>
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { supplierReportHead } from "@/utils/head";
export default {
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    overlay: false,
    search: "",
    form: {},
    loadingSummary: true,
    summaries: [],
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummaries()]);
  },
  components: { DataTable },
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      suppliers: "index/suppliers",
    }),
    headers() {
      return supplierReportHead(this);
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const body = {
        that: this,
        url: `suppliers_paginate?q=${this.search}`,
        commit: "SET_SUPPLIERS",
      };
      await this.fetch(body);
    },

    async fetchSummaries() {
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get("get_summary_report_suppliers");
        if (data && data.status) {
          this.summaries = data.data;
        }
      } catch (e) {
        console.error("fetchSummaries error", e);
      } finally {
        this.loadingSummary = false;
      }
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
